import { render, staticRenderFns } from "./PmTaskManagementForP.vue?vue&type=template&id=78f58dc2&"
import script from "./PmTaskManagementForP.vue?vue&type=script&lang=js&"
export * from "./PmTaskManagementForP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports